export const NOTIFICATION_EVENTS = "/admin/app/notification-events";
export const NOTIFICATION_TEMPLATES = "/admin/app/notification-templates";
export const NOTIFICATION_EVENT_SETTINGS =
  "admin/notification-events/settings/";
//Dashboard
export const DEFAULT_INFO = "default-info";
export const DEFAULT_ACADEMIC_INFO = "default-academic-info";
export const DEFAULT_DASHBOARD_INFO = "default-dashboard-info";
export const AVAILABLE_COURSE_LIST = "available-course-list";
export const STUDENT_OVERVIEW = "student-overview";
export const SCHOOL_OVERVIEW = "school-overview";
export const INSTRUCTOR_STUDENT_OVERVIEW = "instructor-student-overview";
export const AUDIENCE_OVERVIEW_CHART = "audience-overview-chart";
export const BROWSER_OVERVIEW_CHART = "browser-overview-chart";
export const BUSINESS_OVERVIEW = "business-overview";
export const CONTACT_OVERVIEW = "contact-overview";
export const TEAM_OVERVIEW = "team-overview";
export const DOCTORS_LIST = "doctors-list";
export const UPCOMING_APPOINTMENTS = "upcoming-appointments";
export const DEFAULT_HOSPITAL_INFO = "default-hospital-info";
export const HOSPITAL_ACTIVITIES = "hospital-activities";
export const PATIENT_STATISTICS = "patient-statistics";
export const HRM_BASIC_DATA = "hrm-basic-data";
export const PROJECT_OVERVIEW = "project-overview";
export const YEARLY_HOLIDAY = "yearly-holiday";

//funnel template
export const FUNNEL_TEMPLATE = "/app/funnel";
export const API_FUNNEL_TEMPLATE = "/api/funnel";
export const ONBOARDING = "/app/onboarding";

export const CUSTOMSTARTER = "/app/custom-starter";
export const KNOWLEDGEBASE = "/knowledge-base";
export const AGENCYKNOWLEDGEBASE = "/app/knowledge-base";

export const STATUSMASTER = "/app-status-master";
export const AGENCYSTATUSMASTER = "/app/status-checker";

// api
export const ACCOUNTS = "app/accounts/all";
export const GROUP_REPORTING = "app/accounts/all";

export const REPORTING_REGISTER = "app/reporting/register";

//custom value url
export const ACCOUNT_CUSTOMVALUES = "app/custom";

export const BUTTONS = "app/applet/buttons";
export const BUTTON_FOLDERS = "app/applet/buttons/folder";

export const PAGES = "app/pages";

export const REPORTING_FETCH_DATA = "app/reporting/data";
export const DELETE_ACCOUNT = "app/account";
export const EMPLOYEE_OVERVIEW = "employee-overview";

//Sample pages
export const REPORTS = "reports";
export const CALENDARS = "calendars";
export const STAGES = "stages";
export const TASKS = "tasks";

//Profile
export const MY_PROFILE = "/my-profile";
export const All_NOTIFICATION = "/all-notifications";
export const LOGOUT = "/admin/log-out";

//app setting view
export const APP_SETTINGS = "/app-setting";
export const GENERAL_SETTINGS = "general-settings";
export const APP_ADMIN_SETTINGS = "/app-admin-setting";

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = "/get-re-captcha-setting";
//Sms settings
export const GET_SMS_SETTINGS_INFO = "get-sms-setting-info";
//Email settings
export const GET_EMAIL_SETTINGS = "/admin/app/settings/delivery-settings";

//DataTable
export const DATATABLE_DATA = "crud";
export const DATATABLE_SEARCH_SELECT = "/datatable/name";
export const DATATABLE_SERVER_SEARCH_SELECT =
  "/datatable/serverside/selectable-name";
export const CONTACT_UPLOAD_REQUEST = "/admin/bulk-upload/upload-requests";
export const CONTACT_SHOW_REQUEST = "/admin/bulk-upload/request/show";
export const CONTACT_REQUEST_APPROVE =
  "/admin/bulk-upload/approve/contact-upload";
export const CONTACT_UPLOAD_DELETE =
  "/admin/bulk-upload/approve/contact-delete";
export const CONTACT_LIST = "/admin/bulk-upload/get-contacts";

//Custom TAble
export const CUSTOM_TABLE = "admin/app/custom-tables";

//roles and users
export const ROLES = "admin/auth/roles";
export const USERS = "admin/auth/users";
export const USERS_LIST = "user-list";
export const ALL_USERS = "all-users";
export const GET_USERS = "get/users";
export const GET_STATUSES = "admin/app/statuses";
export const INVITE_USER = "/admin/auth/users/invite-user";
export const DETACH_ROLES = "admin/auth/users/detach-roles/";
export const UPDATE_USER_NAME = "/update-user-name/";
export const CHECK_USER_ROLE = "admin/auth/user/role/";

//Notification
export const NOTIFICATIONS = "/admin/user/notifications";
export const AUTHENTICATE_USER = "/admin/authenticate-user";
export const LOGIN_USER = "/login-user";

// Language
export const LANGUAGE = "languages";
export const BASIC_SETTINGS = "/get-basic-setting-data";

// Social links
export const CHANGE_SOCIAL_LINKS = "/change-social-link";

//Payment Methods
export const GET_STARTED = "/admin/get-started";
export const PAYMENT_METHOD = "/payment-method";
export const GET_PAYMENT_METHOD_STATUS = "/payment-method-status";
export const GET_STRIPE_STATUS = "/stripe-status";
export const GET_PAYPAL_STATUS = "/paypal-status";
export const STRIPE_GHL_CUSTOMER_PORTAL_LINK = "/ghlstripe/customer-potal/link";
export const USER_STRIPE_SECRET_KEY = "/stripe/pass";

//Button page
export const BUTTON_PAGE = "/button-page";

//Affiliate Links
export const USER_AFFILIATE_LINK = "/affiliate";
export const VMEDIA_AFFILIATE_LINK = "http://vmedia.com/get-started/";
export const AFFILIATE_LINK_CLICKED = "affiliate-link-clicked";
export const USER_AFFILIATE_DASHBOARD_STATS_INFO =
  "user/affiliate/dashboard/info";
export const USER_AFFILIATE_DASHBOARD_STATS_INFO_FILTER =
  "user/affiliate/dashboard/filter";
export const ADMIN_AFFILIATE_MANAGEMENT_LISTING = "app/affiliate/listing";
export const ADMIN_AFFILIATE_MANAGEMENT_SHOW = "admin/user/affiliate";
export const ADMIN_AFFILIATE_DASHBOARD = "/user/affiliate/dashboard";
//Api Interface
export const API_INTERFACE = "app/api-interface";

//Request Contact List
export const REQUEST_CONTACT_LINK = "";

//Applet links
export const QR_CODE = "/app/applet/qrcode";
export const DNS = "/app/applet/dnshelper";
export const FAKER = "/app/applet/faker";
export const INVOICE = "/app/applet/invoices";
export const ACCOUNTS_TAGS = "/app/location-tag";
export const CONTACTS_FROM_TAGS = "/app/applet/spinner/contacts";
export const GET_GOOGLE_SPREADSHEETS =
  "/app/eventsHandler/google/account/googlesheets/";
export const GET_GOOGLE_SHEETS = "/app/eventsHandler/google/googlesheet/";
export const GET_GOOGLE_SHEET_HEADER = "/app/eventsHandler/google/googlesheet/";
export const GET_USER_GOOGLE_ACCOUNTS =
  "/app/eventsHandler/google/user/google-accounts";
export const GET_GOOGLE_OAUTH_URL =
  "/app/eventsHandler/google/google-oauth2-url";

//Event Trigger
export const WEBHOOK_EVENT_HANDLER = "/app/eventsHandler";
export const WEBHOOK_EVENT_HANDLER_DETAIL = "/app/eventsHandler/edit";
export const WEBHOOK_EVENT_HANDLER_GOOGLE_SHEET =
  "/app/eventsHandler/googlesheet";
export const EVENT_TRIGGER_UPDATE = "/app/eventsHandler/update/trigger";
export const EVENT_HADLER_TRIGGER = "/app/eventsHandler/trigger";
export const WEBHOOK_EVENT_HANDLER_LIST = "/app/eventsHandler/list";

//Service
export const SERVICE_LISTING = "/service/list";
export const USER_SERVICE_LISTING = "/user/service/list";
export const FREE_SERVICE_LISTING = "/service/list/free";
export const USER_SERVICE = "/user/service";
export const USER_SERVICE_LINKS = "/user/services/link";

// api
export const USER_SERVICE_LINKS_API = "/api/user/services/link";

export const SERVICE = "/service";
export const FREE_SERVICE_LINK = "/free/services/link";

//Service Package
export const SERVICE_PACKAGE_LIST = "/service-package/list";
export const REFERRAL_SERVICE_PACKAGE_LIST = "/refer_and_earn/list";
export const SERVICE_PACKAGE_ALL = "/service-package/all";
export const SERVICE_PACKAGE = "/service-package";
export const SERVICE_PACKAGE_STATS = "/service-package/stats";
export const SERVICE_PACKAGE_USERS = "/service-package/users";
export const MY_SUBSCRIPTION = "/stripe/customer/portal";

//user
export const CURRENT_USER = "/me";
export const USER_MANAGEMENT = "/users-and-roles";

//Links
export const LINKS = "service-links";

//services names
export const SERVICES_NAMES = "user-service/name";

//magic links
export const MAGIC_LINKS = "admin/bulk-upload/magiclinks";

//Privacy
export const PRIVACY = "/privacy";

// google business
export const BUSINESS_LOCATIONS = "/business/locations";
export const BUSINESS_LOCATIONS_REVIEWS =
  "/business/locations/{location}/reviews";
export const BUSINESS_LOCATIONS_REVIEW = "/business/{location}/review";

// signature
export const PREFIX = "app";
export const DOCUMENTS = "esignature";
export const LIST_DOCUMENTS = `/${PREFIX}/${DOCUMENTS}/list-documents`;
export const SAVE_DOCUMENT = `/${PREFIX}/${DOCUMENTS}/document`;
export const CURRENT_SIGNER_LINK = `/${PREFIX}/${DOCUMENTS}/get-current-link`;
export const SAVE_COPY_DOCUMENT = `/${PREFIX}/${DOCUMENTS}/copy`;
export const UPDATE_DOCUMENT = `/${PREFIX}/${DOCUMENTS}/update-document`;
export const DELETE_DOCUMENT = `/${PREFIX}/${DOCUMENTS}/delete-document`;
export const SIGNATURE_CUSTOM_VALUES = `/${PREFIX}/${DOCUMENTS}/custom-values`;
export const SIGNATURE_CUSTOM_FIELDS = `/${PREFIX}/${DOCUMENTS}/custom-fields`;
export const ADD_DOCUMENT = `${DOCUMENTS}/add-document`;
export const EDIT_DOCUMENT = `${DOCUMENTS}/edit-document`;
export const CUSTOMIZE_DOCUMENT = `${DOCUMENTS}/customize-document`;
export const LIST_GOOGLE_DRIVE_FOLDERS = `/${PREFIX}/${DOCUMENTS}/google-drive-folders`;

export const GET_USER_GOOGLE_ACCOUNTS_SIGNATURE = `/${PREFIX}/${DOCUMENTS}/google/user/google-accounts`;
export const GET_GOOGLE_OAUTH_URL_SIGNATURE = `/${PREFIX}/${DOCUMENTS}/google/google-oauth2-url`;

export const FILL_DOCUMENT = `esignature/fill`;

//Livechat Urls

export const CONVERSATIONS = "api/livechat/conversations";
export const CHATUSERS = "api/livechat/users";
export const ABLYINIT = "api/livechat/init";
export const CONVERSATIONS_MESSAGE = "api/livechat/conversations_message";

//unauth external route here for livechat.
export const UNAUTHABLYINIT = "/extern/livechat/init";
export const UNAUTHCONVERSATIONS = "/extern/livechat/conversations";
export const UNAUTHCONVERSATIONS_MESSAGE =
  "extern/livechat/conversations_message";
export const UNAUTHCHATUSERS = "extern/livechat/users";

//task url
export const ALLTASK = "api/task/steps/tasks";
export const TASKCOUNT = "api/task/tasks/steps/count";

export const ARCHIVETASK = "/api/task/archiveTask";
export const CREATE_TASK = "api/task/tasks";
export const EXPORT_TASK = "api/task/export-csv";

export const BASE_TASK = "api/task";
export const TASK_PROCEDURE = "api/task/procedure";

export const CREATE_COMMENT = "api/task/comments";
export const CREATE_COLUMN = "api/task/steps";
export const CREATE_PROJECT = "api/task/projects";
export const ACCOUNTS_PROJECT = "api/task/accounts/projects";
export const CREATE_TAG = "api/task/tags";
export const CREATE_PROPERTY = "api/task/priorities";
export const CREATE_LOG_TIMER = "api/task/loggers";
export const UPDATE_LOG_TIMER = "api/task/loggers-all";

export const CREATE_TRIGGER = "api/task/trigger_settings";
export const CREATE_TRIGGER_NAME = "api/task/triggers";
export const CREATE_TRIGGER_OPTION = "api/task/options";
export const CREATE_FORM = "api/task/forms";
export const CREATE_EMAIL = "app/mail/notifications";
export const ACTIVATION = "api/task/notifications/activation";
export const GET_SLACK_TOKEN = "api/task/slack/token";
export const GET_SLACK_CHANNELS = "api/task/slack/channels";
export const GET_SLACK_CONFIG = "api/task/slack/config";
export const DISCONECT_SLACK = "api/task/slack/disconnect";
export const CUSTOM_FIELDS = "api/task/custom-fields";
export const CREATE_EMAIL_TEMPLATE = "api/task/templates";
export const STEP_MASS_UPDATE = "api/task/steps-mass";


export const GET_OPPORTUNITIES = "api/task/tasks/opportunities";
export const CREATE_DASHBOARD_ITEMS = "app/ghl_customization";
export const GET_CUSTOMIZATION_THEMES = "app/ghl_customization/themes";
export const RESET_DASHBOARD_THEMES = "app/ghl_customization/reset-theme";
export const DASHBOARD_RESTRICTION = "app/ghl_customization";

export const GET_LOGIN_CUSTOM = "app/ghl_customization/get-login-custom";
export const GET_LOGIN_PAGES = "app/ghl_customization/get-login-pages";
export const RESET_LOGIN_PAGE = "app/ghl_customization/reset-login-page";

export const GET_LOADER_CUSTOM = "app/ghl_customization/get-custom-loader";
export const GET_LOADER_PAGES = "app/ghl_customization/get-loader-pages";
export const RESET_LOADER_PAGE = "app/ghl_customization/reset-loader-page";

//workflow entities
export const GET_ENTITY_LIST = "api/workflowentity/entities/all";
export const CREATE_ENTITY = "api/workflowentity/entity";
export const UPDATE_ENTITY = "api/workflowentity/entity";
export const DELETE_ENTITY = "api/workflowentity/entity";

// location creator
export const SAVE_DATA = "app/location/creator/save";
export const GET_SNAPSHOTS_LIST = "app/location/creator/snapshops";
export const GET_ACCOUNTS_LIST = "app/location/creator/accounts";
export const GET_AGENCIES_LIST = "app/location/creator/agency";
export const GET_TAGS_LIST = "app/location/creator/event/tag";
export const LOCATION_CREATE_PAGE = "location-action";
export const GET_TEMPLATES_LIST = "app/location/creator/templates";
export const UPDATE_TEMPLATE_STATUS = "app/location/creator/status";
export const DUPLICATE_TEMPLATE = "app/location/creator/duplicate";
export const TEMPLATE_LOGS = "app/location/creator/logs";
export const GET_ACCOUNTS_BY_COMPANYID =
  "app/location/creator/company/accounts";
export const DELETE_CUSTOM_VALUE = "app/location/creator/move/cv/";
export const DELETE_USER = "app/location/creator/move/user/";
export const DELETE_TAG = "app/location/creator/move/tag/";
export const TEST_WEBHOOK_URL = "app/location/creator/webhook/test";
export const SAVE_WEBHOOK_URL = "app/location/creator/webhook/save";
export const GET_WEBHOOK_URL = "app/location/creator/webhook/get";

export const FREEBIES = "api/freebies";

export const TIME_SORT_COMMENT = 7;


export const CUSTOM_SEARCH_ACTIONS = [
  {
    id: "0.general.data.0",
    name: "Mobile App",
  },
  {
    id: "1.general.data.1",
    name: "Media Storage",
  },
  {
    id: "2.general.data.1",
    name: "Media library",
  },
  {
    id: "3.general.data.2",
    name: "Memberships",
  },
  {
    id: "4.general.data.3",
    name: "Membership products",
  },
  {
    id: "a4.general.data.3",
    name: "Membership courses",
  },
  {
    id: "a4.general.data.4",
    name: "Membership courses analytics",
  },
  {
    id: "5.launchpad.data.0",
    name: "Launchpad",
  },
  {
    id: "6.dashboard.data.0",
    name: "Dashboard",
  },
  {
    id: "7.conversations.data.0",
    name: "Conversations",
  },
  {
    id: "8.conversations.data.1",
    name: "Manual Actions",
  },
  {
    id: "9.conversations.data.2",
    name: "conversations Snippets",
  },
  {
    id: "10.conversations.data.2",
    name: "Snippets",
  },
  {
    id: "11.conversations.data.2",
    name: "Add Snippet",
  },
  {
    id: "12.conversations.data.3",
    name: "conversations trigger links",
  },
  {
    id: "13.conversations.data.3",
    name: "trigger links",
  },
  {
    id: "14.conversations.data.3",
    name: "Add links",
  },
  {
    id: "15.conversations.data.4",
    name: "analyze conversations trigger links",
  },
  {
    id: "16.conversations.data.4",
    name: "analyze trigger links",
  },
  {
    id: "17.settings.data.0",
    name: "Friendly Business Name",
  },
  {
    id: "18.settings.data.0",
    name: "Legal Business Name",
  },
  {
    id: "19.settings.data.0",
    name: "Business Email",
  },
  {
    id: "20.settings.data.0",
    name: "Business Phone",
  },
  {
    id: "21.settings.data.0",
    name: "Business Website",
  },
  {
    id: "22.settings.data.0",
    name: "Business Niche",
  },
  {
    id: "23.settings.data.0",
    name: "API Key",
  },
  {
    id: "24.settings.data.0",
    name: "Business Logo",
  },
  {
    id: "25.settings.data.0",
    name: "General Information",
  },
  {
    id: "26.settings.data.0",
    name: "Representative Email",
  },
  {
    id: "27.settings.data.0",
    name: "Job Position",
  },
  {
    id: "28.settings.data.0",
    name: "Phone Number (With Country Code)",
  },
  {
    id: "29.settings.data.0",
    name: "Authorized Representative",
  },
  {
    id: "30.settings.data.0",
    name: "Contact Deduplication Preferences",
  },
  {
    id: "31.settings.data.0",
    name: "Edit Street Address",
  },
  {
    id: "32.settings.data.0",
    name: "Edit City",
  },
  {
    id: "33.settings.data.0",
    name: "Edit Zip Code",
  },
  {
    id: "34.settings.data.0",
    name: "Edit Postal Code",
  },
  {
    id: "35.settings.data.0",
    name: "Edit State",
  },
  {
    id: "36.settings.data.0",
    name: "Edit Prov",
  },
  {
    id: "37.settings.data.0",
    name: "Edit Region",
  },
  {
    id: "38.settings.data.0",
    name: "Edit Country",
  },
  {
    id: "39.settings.data.0",
    name: "Edit Time Zone",
  },
  {
    id: "40.settings.data.0",
    name: "Edit Platform Language",
  },
  {
    id: "41.settings.data.0",
    name: "Edit Outbound communication language for custom values",
  },
  {
    id: "42.settings.data.0",
    name: "Edit Business Physical Address",
  },
  {
    id: "43.settings.data.0",
    name: "Change Business Type",
  },
  {
    id: "44.settings.data.0",
    name: "Edit Business Industry",
  },
  {
    id: "45.settings.data.0",
    name: "Edit Business Registration ID Type",
  },
  {
    id: "46.settings.data.0",
    name: "Edit Business Registration Number",
  },
  {
    id: "47.settings.data.0",
    name: "My business is Not registered",
  },
  {
    id: "48.settings.data.0",
    name: "Edit Business Regions of Operations",
  },
  {
    id: "49.settings.data.0",
    name: "Edit Business Information",
  },
  {
    id: "50.settings.data.0",
    name: "Edit Incoming Call Timeout",
  },
  {
    id: "51.settings.data.0",
    name: "Call & Voicemail Settings",
  },
  {
    id: "52.settings.data.0",
    name: "Edit Missed Call Text Back",
  },
  {
    id: "53.settings.data.0",
    name: "Enable missed call text back",
  },
  {
    id: "54.settings.data.0",
    name: "General",
  },
  {
    id: "55.settings.data.0",
    name: "Settings",
  },
  {
    id: "56.settings.data.0",
    name: "Allow Duplicate Contact",
  },
  {
    id: "57.settings.data.0",
    name: "Allow Duplicate Opportunity",
  },
  {
    id: "58.settings.data.0",
    name: "Merge Facebook Contacts By Name",
  },
  {
    id: "59.settings.data.0",
    name: "Disable Contact Timezone",
  },
  {
    id: "60.settings.data.0",
    name: "Mark Emails as Invalid due to Hard Bounce",
  },
  {
    id: "61.settings.data.0",
    name: "Validate Phone numbers when first SMS is sent to a new contact",
  },
  {
    id: "62.settings.data.0",
    name: "Make Email compliant by adding an Unsubscribe link in your email.",
  },
  {
    id: "63.settings.data.1",
    name: "Personal data",
  },
  {
    id: "64.settings.data.1",
    name: "Edit Personal Logo",
  },
  {
    id: "65.settings.data.1",
    name: "Edit Platform Language",
  },
  {
    id: "66.settings.data.1",
    name: "User Availability",
  },
  {
    id: "67.settings.data.1",
    name: "Edit Meeting Location",
  },
  {
    id: "68.settings.data.1",
    name: "Edit Time Zone",
  },
  {
    id: "69.settings.data.1",
    name: "Edit Available Hours",
  },
  {
    id: "70.settings.data.1",
    name: "Email Signature",
  },
  {
    id: "71.settings.data.1",
    name: "Enable Signature on All Outgoing Messages",
  },
  {
    id: "72.settings.data.1",
    name: "Include this signature before quoted text in replies",
  },
  {
    id: "73.settings.data.1",
    name: "Calendar Configuration",
  },
  {
    id: "74.settings.data.1",
    name: "Profile Integrations",
  },
  {
    id: "75.settings.data.1",
    name: "Zoom",
  },
  {
    id: "76.settings.data.1",
    name: "Outlook Calendar",
  },
  {
    id: "77.settings.data.1",
    name: "Email (2-way sync)",
  },
  {
    id: "78.settings.data.1",
    name: "Gmail",
  },
  {
    id: "79.settings.data.1",
    name: "Outlook",
  },
  {
    id: "80.settings.data.1",
    name: "Change password",
  },
  {
    id: "81.settings.data.1",
    name: "Sign Out Everywhere",
  },
  {
    id: "82.settings.data.1",
    name: "Private Mode for Synced Events",
  },
  {
    id: "83.settings.data.2",
    name: "Notifications",
  },
  {
    id: "84.settings.data.2",
    name: "Conversation Notifications",
  },
  {
    id: "85.settings.data.2",
    name: "Notify for all new conversations & messages initiated with the account",
  },
  {
    id: "86.settings.data.2",
    name: "Notify when a conversation gets assigned to me",
  },
  {
    id: "87.settings.data.2",
    name: "Notify for new messages on a conversation I am assigned to",
  },
  {
    id: "88.settings.data.2",
    name: "Task Notifications",
  },
  {
    id: "89.settings.data.2",
    name: "Notify when a task gets assigned to me",
  },
  {
    id: "90.settings.data.2",
    name: "Notify when a new review is received",
  },
  {
    id: "91.settings.data.2",
    name: "Notify when new wordpress service is purchased",
  },
  {
    id: "92.settings.data.3",
    name: "billing",
  },
  {
    id: "93.settings.data.3",
    name: "company billing",
  },
  {
    id: "94.settings.data.3",
    name: "location billing",
  },
  {
    id: "95.settings.data.4",
    name: "Billing payment",
  },
  {
    id: "96.settings.data.5",
    name: "Billing Wallet & Transactions",
  },
  {
    id: "97.settings.data.6",
    name: "Calendar Settings",
  },
  {
    id: "98.settings.data.6",
    name: "Create Calendar Group",
  },
  {
    id: "99.settings.data.6",
    name: "Create Calendar",
  },
  {
    id: "100.settings.data.6",
    name: "Calendar Groups",
  },
  {
    id: "101.settings.data.6",
    name: "Calendar Service Menu",
  },
  {
    id: "102.settings.data.6",
    name: "Calendar Rooms",
  },
  {
    id: "103.settings.data.6",
    name: "Calendar Equipment",
  },
  {
    id: "104.settings.data.7",
    name: "Calendar Preferences",
  },
  {
    id: "105.settings.data.7",
    name: "Calendar Account Preference",
  },
  {
    id: "106.settings.data.8",
    name: "Create AI Bot",
  },
  {
    id: "107.settings.data.9",
    name: "Calendar Availability",
  },
  {
    id: "108.settings.data.10",
    name: "Calendar Connections",
  },
  {
    id: "109.settings.data.11",
    name: "Email Services",
  },
  {
    id: "110.settings.data.11",
    name: "SMTP Service",
  },
  {
    id: "111.settings.data.11",
    name: "Reply & Forward Settings",
  },
  {
    id: "112.settings.data.11",
    name: "Email Analytics",
  },
  {
    id: "113.settings.data.11",
    name: "Risk Assessment",
  },
  {
    id: "114.settings.data.11",
    name: "Bounce Classification",
  },
  {
    id: "115.settings.data.11",
    name: "Postmaster Tools",
  },
  {
    id: "116.settings.data.12",
    name: "Add Payment Method",
  },
  {
    id: "117.settings.data.13",
    name: "My Staff",
  },
  {
    id: "118.settings.data.13",
    name: "Teams",
  },
  {
    id: "119.settings.data.13",
    name: "Add Employee",
  },
  {
    id: "120.settings.data.14",
    name: "Opportunities & Pipelines",
  },
  {
    id: "121.settings.data.14",
    name: "Customize opportunity settings",
  },
  {
    id: "122.settings.data.15",
    name: "Create new pipeline",
  },
  {
    id: "123.settings.data.16",
    name: "Global Workflow Settings",
  },
  {
    id: "124.settings.data.16",
    name: "Automation",
  },
  {
    id: "125.settings.data.17",
    name: "Conversation AI Bot",
  },
  {
    id: "126.settings.data.17",
    name: "Conversation AI",
  },
  {
    id: "127.settings.data.18",
    name: "Labs",
  },
  {
    id: "128.settings.data.19",
    name: "Add New Domain",
  },
  {
    id: "129.settings.data.20",
    name: "Audit Logs",
  },
  {
    id: "130.settings.data.21",
    name: "Tags",
  },
  {
    id: "131.settings.data.22",
    name: "URL Redirects",
  },
  {
    id: "132.settings.data.23",
    name: "Add a Redirect",
  },
  {
    id: "133.settings.data.24",
    name: "Domains",
  },
  {
    id: "134.settings.data.25",
    name: "Integrations",
  },
  {
    id: "135.settings.data.26",
    name: "Facebook Form Fields Mapping",
  },
  {
    id: "136.settings.data.27",
    name: "TikTok Form Fields Mapping",
  },
  {
    id: "137.settings.data.28",
    name: "SMS Providers",
  },
  {
    id: "138.settings.data.28",
    name: "Phone Numbers",
  },
  {
    id: "139.settings.data.28",
    name: "Number Pool",
  },
  {
    id: "140.settings.data.29",
    name: "Voice AI Agents",
  },
  {
    id: "141.settings.data.30",
    name: "Voice AI Agents",
  },
  {
    id: "142.settings.data.31",
    name: "Create AI Agents",
  },
  {
    id: "143.settings.data.31",
    name: "Create Agents",
  },
  {
    id: "144.settings.data.32",
    name: "Add Number",
  },
  {
    id: "145.settings.data.32",
    name: "Add Phone Number",
  },
  {
    id: "146.settings.data.33",
    name: "Usage Summary",
  },
  {
    id: "147.settings.data.34",
    name: "Regulatory Bundle / Address",
  },
  {
    id: "148.settings.data.35",
    name: "Trust Center",
  },
  {
    id: "149.settings.data.36",
    name: "Messaging Analytics",
  },
  {
    id: "150.settings.data.37",
    name: "Phone Advanced Settings",
  },
  {
    id: "151.settings.data.37",
    name: "SMS Provider - Phone Advanced Settings",
  },
  {
    id: "152.settings.data.37",
    name: "Number Intelligence - Phone Advanced Settings",
  },
  {
    id: "153.settings.data.37",
    name: "Voice Calls - Phone Advanced Settings",
  },
  {
    id: "154.settings.data.37",
    name: "Voicemail & Missed Call Textback - Phone Advanced Settings",
  },
  {
    id: "155.settings.data.37",
    name: "SMS Compliance - Phone Advanced Settings",
  },
  {
    id: "156.settings.data.37",
    name: "Messaging Limit - Phone Advanced Settings",
  },
  {
    id: "157.settings.data.37",
    name: "Restriction History - Phone Advanced Settings",
  },
  {
    id: "158.settings.data.38",
    name: "WhatsApp Messaging",
  },
  {
    id: "159.settings.data.39",
    name: "Objects",
  },
  {
    id: "160.settings.data.40",
    name: "Add Custom Object",
  },
  {
    id: "161.settings.data.41",
    name: "Custom Fields",
  },
  {
    id: "162.settings.data.42",
    name: "Custom Values",
  },
  {
    id: "163.settings.data.43",
    name: "Manage Scoring",
  },
  {
    id: "164.settings.data.43",
    name: "Engagement Score",
  },
  {
    id: "165.settings.data.44",
    name: "LinkedIn Form Fields Mapping",
  },
  {
    id: "166.settings.data.45",
    name: "Private Integrations",
  },
  {
    id: "167.settings.data.46",
    name: "Conversation Providers",
  },
  {
    id: "168.calendars.data.0",
    name: "Calendars",
  },
  {
    id: "169.calendars.data.1",
    name: "Appointments",
  },
  {
    id: "170.calendars.data.2",
    name: "Book Appointment",
  },
  {
    id: "171.custom_Fields.data.0",
    name: "Add Custom Field",
  },
  {
    id: "172.custom_Fields.data.0",
    name: "Create Custom Field",
  },
  {
    id: "173.custom_Fields.data.1",
    name: "Add Custom Field Folder",
  },
  {
    id: "174.custom_Fields.data.1",
    name: "Create Custom Field Folder",
  },
  {
    id: "175.opportunities.data.0",
    name: "Create opportunity",
  },
  {
    id: "176.opportunities.data.0",
    name: "new opportunity",
  },
  {
    id: "177.opportunities.data.0",
    name: "create new opportunity",
  },
  {
    id: "178.opportunities.data.1",
    name: "Opportunities",
  },
  {
    id: "179.opportunities.data.2",
    name: "Create new pipeline",
  },
  {
    id: "180.opportunities.data.3",
    name: "Pipelines",
  },
  {
    id: "181.opportunities.data.4",
    name: "Pipelines imports",
  },
  {
    id: "182.opportunities.data.4",
    name: "imports",
  },
  {
    id: "183.opportunities.data.5",
    name: "Pipelines bulk-actions",
  },
  {
    id: "184.opportunities.data.5",
    name: "bulk-actions",
  },
  {
    id: "185.workflows.data.0",
    name: "Workflows",
  },
  {
    id: "186.workflows.data.1",
    name: "Create Workflows",
  },
  {
    id: "187.workflows.data.1",
    name: "New Workflows",
  },
  {
    id: "188.reporting.data.0",
    name: "Reporting",
  },
  {
    id: "189.reporting.data.0",
    name: "reporting custom",
  },
  {
    id: "190.reporting.data.0",
    name: "Reports Overview",
  },
  {
    id: "191.reporting.data.1",
    name: "Google Ads",
  },
  {
    id: "192.reporting.data.1",
    name: "Google Ads Report",
  },
  {
    id: "193.reporting.data.2",
    name: "Facebook Ads",
  },
  {
    id: "194.reporting.data.3",
    name: "Attribution Report",
  },
  {
    id: "195.reporting.data.4",
    name: "Call Reporting",
  },
  {
    id: "196.reporting.data.5",
    name: "Appointments Report",
  },
  {
    id: "197.reporting.data.6",
    name: "Agent Report",
  },
  {
    id: "198.payments.data.0",
    name: "Payments",
  },
  {
    id: "199.payments.data.1",
    name: "Invoices",
  },
  {
    id: "200.payments.data.2",
    name: "Invoices Settings",
  },
  {
    id: "201.payments.data.3",
    name: "Recurring Templates",
  },
  {
    id: "202.payments.data.4",
    name: "Orders",
  },
  {
    id: "203.payments.data.5",
    name: "Subscriptions",
  },
  {
    id: "204.payments.data.6",
    name: "Transactions",
  },
  {
    id: "205.payments.data.7",
    name: "Products",
  },
  {
    id: "206.payments.data.8",
    name: "Create Product",
  },
  {
    id: "207.payments.data.9",
    name: "Import Stripe Product",
  },
  {
    id: "208.payments.data.10",
    name: "Coupons",
  },
  {
    id: "209.payments.data.11",
    name: "Create Coupon",
  },
  {
    id: "210.payments.data.12",
    name: "Tax Settings",
  },
  {
    id: "211.payments.data.13",
    name: "Integrations",
  },
  {
    id: "212.payments.data.14",
    name: "Estimates",
  },
  {
    id: "213.payments.data.15",
    name: "Proposals & Estimates",
  },
  {
    id: "214.payments.data.15",
    name: "Estimates",
  },
  {
    id: "215.payments.data.15",
    name: "Documents & Contracts",
  },
  {
    id: "216.payments.data.16",
    name: "Invoice Templates",
  },
  {
    id: "217.payments.data.17",
    name: "Abandoned Checkouts",
  },
  {
    id: "218.payments.data.18",
    name: "Payment Links",
  },
  {
    id: "219.payments.data.19",
    name: "Create Payment Links",
  },
  {
    id: "220.payments.data.19",
    name: "New Payment Links",
  },
  {
    id: "221.payments.data.20",
    name: "Import products by CSV",
  },
  {
    id: "222.payments.data.21",
    name: "Collection",
  },
  {
    id: "223.payments.data.22",
    name: "Create Collection",
  },
  {
    id: "224.payments.data.22",
    name: "New Collection",
  },
  {
    id: "225.payments.data.23",
    name: "Inventory",
  },
  {
    id: "226.payments.data.24",
    name: "Product Reviews and Ratings",
  },
  {
    id: "227.payments.data.25",
    name: "add tax",
  },
  {
    id: "228.payments.data.26",
    name: "Notifications Settings",
  },
  {
    id: "229.payments.data.27",
    name: "Shipping & Delivery",
  },
  {
    id: "230.payments.data.27",
    name: "Shipping Zones",
  },
  {
    id: "231.payments.data.28",
    name: "Add Shipping Zones",
  },
  {
    id: "232.payments.data.29",
    name: "Shipping origin",
  },
  {
    id: "233.payments.data.30",
    name: "subscriptions settings",
  },
  {
    id: "234.payments.data.31",
    name: "receipts settings",
  },
  {
    id: "235.payments.data.32",
    name: "new Estimates",
  },
  {
    id: "236.custom_Values.data.0",
    name: "Add Custom Values",
  },
  {
    id: "237.custom_Values.data.0",
    name: "Create Custom Values",
  },
  {
    id: "238.custom_Values.data.1",
    name: "Add Custom Values Folder",
  },
  {
    id: "239.custom_Values.data.1",
    name: "Create Custom Values Folder",
  },
  {
    id: "240.sites.data.0",
    name: "Sites",
  },
  {
    id: "241.sites.data.0",
    name: "Funnels",
  },
  {
    id: "242.sites.data.1",
    name: "Funnels",
  },
  {
    id: "243.sites.data.2",
    name: "New Funnel",
  },
  {
    id: "244.sites.data.3",
    name: "Create funnel folder",
  },
  {
    id: "245.sites.data.4",
    name: "Websites",
  },
  {
    id: "246.sites.data.5",
    name: "New Website",
  },
  {
    id: "247.sites.data.6",
    name: "Create website folder",
  },
  {
    id: "248.sites.data.7",
    name: "Blogs",
  },
  {
    id: "249.sites.data.8",
    name: "Wordpress",
  },
  {
    id: "250.sites.data.9",
    name: "client portal",
  },
  {
    id: "251.sites.data.9",
    name: "client Dashboard",
  },
  {
    id: "252.sites.data.10",
    name: "Create chat widget",
  },
  {
    id: "253.sites.data.10",
    name: "New chat widget",
  },
  {
    id: "254.sites.data.11",
    name: "Add quiz",
  },
  {
    id: "255.sites.data.11",
    name: "Create quiz",
  },
  {
    id: "256.sites.data.11",
    name: "New quiz",
  },
  {
    id: "257.sites.data.12",
    name: "Create quiz folder",
  },
  {
    id: "258.sites.data.13",
    name: "Form Features 🥳",
  },
  {
    id: "259.sites.data.14",
    name: "Forms",
  },
  {
    id: "260.sites.data.15",
    name: "Add Form",
  },
  {
    id: "261.sites.data.16",
    name: "Create Form folder",
  },
  {
    id: "262.sites.data.17",
    name: "Survey Features 🥳",
  },
  {
    id: "263.sites.data.18",
    name: "Forms Submissions",
  },
  {
    id: "264.sites.data.19",
    name: "Surveys",
  },
  {
    id: "265.sites.data.20",
    name: "Add Surveys",
  },
  {
    id: "266.sites.data.21",
    name: "Create Survey folder",
  },
  {
    id: "267.sites.data.22",
    name: "Quizzes",
  },
  {
    id: "268.sites.data.23",
    name: "Survey Submissions",
  },
  {
    id: "269.sites.data.24",
    name: "Chat Widget",
  },
  {
    id: "270.sites.data.24",
    name: "Webchat for your website",
  },
  {
    id: "271.sites.data.25",
    name: "qr codes",
  },
  {
    id: "272.sites.data.25",
    name: "qr-codes",
  },
  {
    id: "273.sites.data.26",
    name: "Stores",
  },
  {
    id: "274.sites.data.27",
    name: "New Store",
  },
  {
    id: "275.sites.data.28",
    name: "Create Store folder",
  },
  {
    id: "276.sites.data.29",
    name: "Webinar Funnels",
  },
  {
    id: "277.sites.data.30",
    name: "New Webinar Funnel",
  },
  {
    id: "278.sites.data.31",
    name: "Create Webinar Funnel folder",
  },
  {
    id: "279.sites.data.32",
    name: "Forms Analytics",
  },
  {
    id: "280.sites.data.33",
    name: "Setup your blog site",
  },
  {
    id: "281.sites.data.33",
    name: "Create blog",
  },
  {
    id: "282.sites.data.34",
    name: "blog Settings",
  },
  {
    id: "283.sites.data.35",
    name: "Create QR code",
  },
  {
    id: "284.sites.data.35",
    name: "New QR code",
  },
  {
    id: "285.sites.data.36",
    name: "Create QR code folder",
  },
  {
    id: "286.sites.data.36",
    name: "New QR code folder",
  },
  {
    id: "279.sites.data.37",
    name: "Survey Analytics",
  },
  {
    id: "279.sites.data.38",
    name: "Quizzes Submissions",
  },
  {
    id: "279.sites.data.39",
    name: "Funnel Analytics",
  },
  {
    id: "279.sites.data.40",
    name: "Website Analytics",
  },
  {
    id: "279.sites.data.41",
    name: "QR Code Analytics",
  },
  {
    id: "287.contacts.data.0",
    name: "Contacts",
  },
  {
    id: "288.contacts.data.0",
    name: "Smart list",
  },
  {
    id: "289.contacts.data.1",
    name: "Contacts Bulk Actions",
  },
  {
    id: "290.contacts.data.2",
    name: "Contacts Restore",
  },
  {
    id: "291.contacts.data.3",
    name: "Tasks List",
  },
  {
    id: "292.contacts.data.4",
    name: "Company List",
  },
  {
    id: "293.contacts.data.5",
    name: "New Company",
  },
  {
    id: "294.contacts.data.6",
    name: "Manage Smart Lists",
  },
  {
    id: "295.contacts.data.7",
    name: "New Contact",
  },
  {
    id: "296.marketing.data.0",
    name: "Marketing",
  },
  {
    id: "297.marketing.data.0",
    name: "Social Planner",
  },
  {
    id: "298.marketing.data.1",
    name: "Email Campaigns",
  },
  {
    id: "299.marketing.data.1",
    name: "create campaign",
  },
  {
    id: "300.marketing.data.1",
    name: "create email compaign folder",
  },
  {
    id: "301.marketing.data.2",
    name: "Email Templates",
  },
  {
    id: "302.marketing.data.2",
    name: "create Email Templates",
  },
  {
    id: "303.marketing.data.2",
    name: "create email Templates folder",
  },
  {
    id: "304.marketing.data.3",
    name: "Snippets",
  },
  {
    id: "305.marketing.data.3",
    name: "Message Templates",
  },
  {
    id: "306.marketing.data.4",
    name: "Trigger Link",
  },
  {
    id: "307.marketing.data.4",
    name: "Link",
  },
  {
    id: "308.marketing.data.4",
    name: "add link",
  },
  {
    id: "309.marketing.data.5",
    name: "Trigger Link analyze",
  },
  {
    id: "310.marketing.data.5",
    name: "analyze Link",
  },
  {
    id: "311.marketing.data.6",
    name: "Affiliate Manager",
  },
  {
    id: "312.marketing.data.6",
    name: "Affiliate",
  },
  {
    id: "313.marketing.data.6",
    name: "payouts",
  },
  {
    id: "314.marketing.data.7",
    name: "Content AI",
  },
  {
    id: "315.marketing.data.8",
    name: "Email statistics",
  },
  {
    id: "316.marketing.data.9",
    name: "Countdown Timer",
  },
  {
    id: "317.marketing.data.10",
    name: "Create Countdown Timer",
  },
  {
    id: "318.marketing.data.10",
    name: "New Countdown Timer",
  },
  {
    id: "319.marketing.data.11",
    name: "Affiliate Manager Dashboard",
  },
  {
    id: "320.marketing.data.12",
    name: "Brand Boards",
  },
  {
    id: "321.marketing.data.13",
    name: "New Brand Boards",
  },
  {
    id: "322.marketing.data.13",
    name: "Create Brand Boards",
  },
  {
    id: "323.marketing.data.14",
    name: "Ad Manager",
  },
  {
    id: "323.marketing.data.15",
    name: "Social Planner statistics",
  },
  {
    id: "324.reputation.data.0",
    name: "Reputation",
  },
  {
    id: "325.reputation.data.0",
    name: "Overview",
  },
  {
    id: "326.reputation.data.0",
    name: "Reputation Overview",
  },
  {
    id: "327.reputation.data.0",
    name: "Send Review Request",
  },
  {
    id: "328.reputation.data.1",
    name: "Requests",
  },
  {
    id: "329.reputation.data.1",
    name: "Reputation Requests",
  },
  {
    id: "330.reputation.data.2",
    name: "Reviews",
  },
  {
    id: "331.reputation.data.2",
    name: "Reputation Reviews",
  },
  {
    id: "332.reputation.data.3",
    name: "Listing",
  },
  {
    id: "333.reputation.data.3",
    name: "Reputation Listing",
  },
  {
    id: "334.reputation.data.4",
    name: "Widget",
  },
  {
    id: "335.reputation.data.4",
    name: "Customize Review Widget",
  },
  {
    id: "336.reputation.data.5",
    name: "settings",
  },
  {
    id: "337.reputation.data.5",
    name: "Review Link",
  },
  {
    id: "338.reputation.data.5",
    name: "Reputation Management",
  },
  {
    id: "339.tags.data.0",
    name: "Add tag",
  },
];
